import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  error: null,
  data: null,
};

export const prizeCurrentMonthSlice = createSlice({
  name: "prize/currentMonth",
  initialState,
  reducers: {
    load: (state, action) => {
      state.isLoading = true;
      state.error = null;
      state.data = null;
    },
    setError(state, action) {
      state.error = action.payload;
      state.isLoading = false;
    },
    setCurrentMonth: (state, action) => {
      state.isLoading = false;
      state.error = null;
      state.data = action.payload;
    },
  },
});
export const prizeCurrentMonthSActions = prizeCurrentMonthSlice.actions;

export default prizeCurrentMonthSlice.reducer;
